<template>
    <div class="drug-container">
        <div class="drug-warp backfff" v-for="(item, index) in drugItems" :key="index">
            <div class="drug-top" :class="{ 'disabled': isDisabled }">
                <div class="top-left">
                    <div class="drug-index">
                        <img :src="imgArr.drugIcon" class="drug-icon">
                        <div class="font600 size14 color6671">中药处方{{ index + 1 }}</div>
                    </div>
                    <div class="drug-type">
                        <!-- <div>类型：</div> -->
                        <el-select ref="select" class="type-select" v-model="item.doseType" placeholder=""
                            :disabled="isDisabled || item.isYlcp == '1'" @change="typeChange($event, item, index)">
                            <el-option v-for="obj in recipeList" :disabled="obj.disabled" :key="obj.value" :label="obj.label" :value="obj.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-popover placement="top" v-if="item.isYlcp == '1'" width="200" trigger="hover"
                        content="医联产品处方明细已做保密处理">
                        <div class="flex align-i-c" slot="reference">
                            <div class="ylBox pointer">医联</div>
                            <span v-if="item.recipeName " class="ml4">{{ item.recipeName }}</span>
                        </div>
                    </el-popover>
                    <div class="drug-total">
                        <!-- 总价￥{{ $toFixed(item.totalPrice) }} -->
                        <span>{{ item.items.length - 1 }}味，单剂{{ computedWeight(item.items) }}g，合计{{ item.weight }}g</span>
                        <el-tooltip v-if="['制膏', '制丸', '打粉'].includes(item.recipeMethod)" effect="dark" placement="top-start">
                            <div slot="content">
                                <template v-if="item.recipeMethod == '制膏'">预计成品重量{{ Math.trunc((item.weight || 0) * 0.4) }}g（制膏量约为药材总重的40%，仅统计单位为g的药材重量）</template>
                                <template v-if="item.recipeMethod == '制丸'">预计成品重量{{ Math.trunc((item.weight || 0) * 0.8) }}g（制丸量约为药材总重的80%，仅统计单位为g的药材重量）</template>
                                <template v-if="item.recipeMethod == '打粉'">预计成品重量{{ Math.trunc((item.weight || 0) * 0.8) }}g（打粉量约为药材总重的80%，仅统计单位为g的药材重量）</template>
                            </div>
                            <span class="el-icon-info drug-total_icon"></span>
                        </el-tooltip>
                    </div>
                </div>
                <div class="top-right flex" v-if="item.isYlcp != '1'">
                    <div v-if="!isDisabled" class="top-right">
                        <el-button :size="btnSize" class="process" @click="openPrescriptionTemplateDialog(index)">追加模版</el-button>
                        <el-button :size="btnSize" class="process" :icon="item.ingredients && item.ingredients.length > 0 ? 'el-icon-check' : ''" @click="handleIngredient(index)">辅料</el-button>
                        <el-button v-if="companyId == 10" :size="btnSize" class="process" :icon="item.processFlag == '1' ? 'el-icon-check' : ''" @click="handleProcess(index)">加工</el-button>
                    </div>
                    <div class="top-right ml10">
                        <el-button :size="btnSize" class="process" @click="printerPrescription(item)">打印</el-button>
                    </div>
                    <!-- <div v-if="!isDisabled" class="top-right"> -->
                    <div class="del see pointer" @click="handlelook(item)">
                        <span class="iconfont icon-yulan"></span>
                    </div>
                    <div class="del see pointer" @click="savePrescriptionTemplate(item)">
                        <span class="iconfont icon-baocun"></span>
                    </div>
                    <div v-if="!isDisabled && item.items && item.items.length>0" class="del pointer" @click="deleteDrugItem(index, item.orderCaseProjectRecipeId)">
                        <span class="iconfont icon-shanch"></span>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div class="drug-list" :class="{ 'disabled': isDisabled }" v-if="item.isYlcp != '1'">
                <el-row>
                    <!-- :filter="'.undraggable'" -->
                    <vuedraggable :options="dragOptions" forceFallback="true" fallbackClass="fallbackClass"
                        touchStartThreshold="20px" fallbackTolerance="20px" delay="200"
                        :disabled="isDisabled || draggableDisabled" v-model="item.items"
                        @end="sortChange($event, index, item.items)" @start="startChange($event, item.items)"
                        @sort="pointChange($event, item.items)">
                        <!-- <transition-group> -->
                        <el-col class="drag-warp" :class="'drugItem pointer'"
                            :span="6" v-for="(kid, drugIndex) in item.items" :key="kid.spuId">
                            <!-- <div class="drug-search" @mouseenter="kid.deleteShow = true" @mouseleave="kid.deleteShow = false"> -->
                            <div class="drug-search" @mouseenter="enterKid(kid, index, drugIndex)"
                                @mouseleave="leaveKid(kid, index, drugIndex)">
                                <div class="pa addNote" v-if="alreadyAdd == `note+ ${index} + ${drugIndex}`">该处方已添加过此药品
                                </div>
                                <div class="pa addNote" v-if="isOwnedTip == `note+ ${index} + ${drugIndex}`">备注为【自备】，该药品将不会纳入划价收费</div>
                                <div class="search-top pr">
                                    <el-tooltip popper-class="return-popover"
                                        v-if="item.doseNum * kid.itemNum > (kid.inventory || 0) && kid.onSale == '1' && kid.isOwned=='0'"
                                        class="item" effect="dark" :content="'库存不足(余' + kid.inventory + ')'"
                                        placement="top-start">
                                        <span class="iconfont icon-jingg colorFE8F mr6 mt6" style="size: 12px;"></span>
                                    </el-tooltip>
                                    <el-tooltip popper-class="return-popover" v-if="kid.onSale == '0' && kid.isOwned=='0'"
                                        class="item" effect="dark" content="药品已停售" placement="top-start">
                                        <span class="iconfont icon-tinshou colorF54A mr6" style="size: 12px;"></span>
                                    </el-tooltip>
                                    <div style="height: 1px;width: 1px;bottom: 150px;"
                                        :ref="'point' + index + drugIndex" class="pa"></div>
                                    <el-popover
                                        :ref="'popover' + index + drugIndex"
                                        placement="bottom-start"
                                        :popper-options="{flip: false, preventOverflow: {boundariesElement: 'viewport', priority: ['bottom']}}"
                                        :visible-arrow="false"
                                        :disabled="draggableFlag"
                                        :value="(customTableText == ('customTable' + index + drugIndex))"
                                        popper-class="search-popper">
                                        <el-input
                                            :class="{ 'colorFE8FDrug': ((item.doseNum || 1) * kid.itemNum > kid.inventory && kid.isOwned=='0'), 'colorF54ADrug': (kid.onSale == '0' || kid.itemId < 0) && kid.isOwned=='0' }"
                                            :ref="'search' + index + drugIndex" :disabled="isDisabled" slot="reference"
                                            class="input-search size14 font600 pointer" type="text" autocomplete="off"
                                            spellcheck="false" size="mini" maxlength="30" v-model.trim="kid.itemName"
                                            placeholder="药名"
                                            @focus="drugFocus(kid.itemName, kid.doseType || item.doseType, index, drugIndex)"
                                            @blur="drugSearchBlur(index, drugIndex)"
                                            @input.native="drugInput($event, kid.itemName,kid.doseType || item.doseType, index, drugIndex)"
                                            @keydown.left.native.prevent="numberInputMove($event, 'left', index, drugIndex)"
                                            @keydown.right.native.prevent="numberInputMove($event, 'right', index, drugIndex)"
                                            @keydown.enter.native="rowClick(drugList[drugListIndex], index, drugIndex)"
                                            @keydown.down.native="numberInputMove($event, 'down', index, drugIndex)"
                                            @keydown.up.native="numberInputMove($event, 'up', index, drugIndex)"
                                            @dragstart.native="preventDefault">
                                        </el-input>
                                        <!-- <div class="customTable" v-if="kid.showTable&&drugList&&drugList.length>0"> -->
                                        <!-- <div class="customTable" v-if="drugList && drugList.length > 0"> -->
                                        <div class="customTable">
                                            <customTable :highlight-current-row="true"
                                                :ref="'customTable' + index + drugIndex"
                                                @row-click="rowClick($event, index, drugIndex)"
                                                :header-cell-style="{ background: '#F5F9FF', }" :column="column"
                                                :tableData="drugList" :showPages="false" height="200">
                                                <template slot="itemNameHeader">
                                                    <div class="flex align-i-c "
                                                        @click="changeSearchType(kid.itemName, kid.doseType || item.doseType, index, drugIndex)">
                                                        <span class="mr4">{{ searchType == '0' ? '饮片名称' : '颗粒名称'
                                                            }}</span>
                                                        <img :src="imgArr.changeType" class="change-icon">
                                                    </div>
                                                </template>
                                            </customTable>
                                        </div>
                                    </el-popover>

                                    <div style="flex-shrink: 0;flex-grow:0;">
                                        <el-input :ref="'dosage' + index + drugIndex" :disabled="isDisabled"
                                            class="input-dosage" type="text" autocomplete="off" spellcheck="false"
                                            maxlength="6" v-model="kid.itemNum" placeholder="用量"
                                            @input="formatNum($event, kid, item, index)"
                                            @blur="dosageBlurFn({ index, drugIndex })"
                                            @focus="dosageFocus(index, drugIndex)"
                                            @keydown.left.native.prevent="numberInputMove($event, 'left', index, drugIndex)"
                                            @keydown.right.native.prevent="numberInputMove($event, 'right', index, drugIndex)"
                                            @keydown.enter.native="searchFocus(index, drugIndex)"
                                            @keydown.down.native="numberInputMove($event, 'down', index, drugIndex)"
                                            @keydown.up.native="numberInputMove($event, 'up', index, drugIndex)"
                                            @dragstart.native="preventDefault"></el-input>
                                        <span>{{ kid.itemUnit }}</span>
                                    </div>
                                </div>
                                <SelectPanel
                                    :ref="'operate' + index + drugIndex"
                                    :class="{ prescription_decoction: true, prescription_decoction_hide: [null, undefined, ''].includes(kid.handling) && kid.isOwned!='1', prescription_decoction_hide_most: [null, undefined, ''].includes(kid.spuId) }"
                                    v-model="kid.handling"
                                    width="100%"
                                    :maxlength="20"
                                    placeholder="煎法"
                                    :columnsNum="4"
                                    :options="handlingOptions"

                                    @focus="decoctionFocus(kid)"
                                    @input="chooseUsage($event, index, drugIndex)"
                                    @enter="operateEnterFn({ index, drugIndex })"
                                    :disabled="isDisabled">
                                    <template slot="prefix">
                                        <div class="isOwned_warp" v-if="kid.isOwned && kid.isOwned == '1'">【自备】</div>
                                    </template>
                                    <template slot="footer">
                                        <div class="prescription_decoction_footer">
                                            <div class="decoction_btn" :class="kid.isOwned && kid.isOwned=='1'?'decoction_btn isOwned':'decoction_btn'" @click="handleIsOwned(index,drugIndex)">【自备】</div>
                                            <div class="decoction_btn" @click="rememberDecoction(kid)">
                                                <span class="decoction_btn_text">记住煎法</span>
                                                <img class="decoction_btn_icon" :src="kid.rememberDecoction === true ? starImgMap.starOn : starImgMap.starOff" />
                                            </div>
                                        </div>
                                    </template>
                                </SelectPanel>
                                <i class="el-icon-close close-item pointer" style="font-size: 14px; color:#9AA0A8"
                                    v-if="kid.deleteShow && item.items.length != 1 && item.items.length != drugIndex + 1 && !isDisabled"
                                    @click="removeDrug(index, drugIndex)"></i>
                            </div>
                        </el-col>
                        <!-- </transition-group> -->
                    </vuedraggable>
                </el-row>
            </div>
            <div class="drug-tips" :class="{ 'disabled': isDisabled }">
                <div class="flex">
                    <div class="doseNumber">
                        <el-input :disabled="isDisabled || item.isYlcp == '1'" maxlength="3" type="text" v-model="item.doseNum" @input="doseNumChange(item, index)" style=" width: 40px;"></el-input>
                        <span>剂</span>
                    </div>
                    <template v-if="item.isYlcp != '1'">
                        <div class="dose">
                            <SelectPanel v-model="item.recipeMethod" width="60px" placeholder="用法" clearable :options="drugMethodOptions.map(v => { return { label: v, value: v } })" @input="handDrugs(item, index, 1, true)" :disabled="isDisabled"></SelectPanel>
                        </div>
                        <div class="dose" v-for="(val, ind) in computedDrugNoteList(item)" :key="ind">
                            <div v-if="val.id == 'mixingBagNum'" class="doseNumber bag" @click="mixingBagNumFocus(index)">
                                每次
                                <el-input
                                    :ref="`mixingBagNum_${index}`"
                                    v-model.trim="item.mixingBagNum"
                                    style="width: 20px;"
                                    oninput="if(isNaN(value)) { value = null }if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+2) } else if ( value.indexOf('.') === 0 ) { value = null }"
                                    :disabled="isDisabled"
                                    :readonly="!val.allowInput"
                                    @blur="mixingBagNumBlur"
                                    @change="handDrugs(item, index, 1)">
                                </el-input>
                                袋
                            </div>
                            <SelectPanel
                                v-else
                                v-model="item[val.id]"
                                :width="val.width || '80px'"
                                :columnsNum="3"
                                :options="val.kid.map(v => { return { label: v, value: v } })"
                                :placeholder="val.name"
                                :disabled="isDisabled"
                                :readonly="!val.allowInput"
                                clearable
                                @input="doseSelectInput(item, val.id);handDrugs(item, index, 1)">
                            </SelectPanel>
                        </div>
                        <div class="dose">
                            <el-input :disabled="isDisabled" placeholder="备注" type="text" style="width: 140px;"
                                v-model="item.remark" @blur="handDrugs(item, index, 1)"></el-input>

                        </div>
                    </template>
                </div>
                <div class="color6671 size14"> ￥{{ $toFixed(item.totalPrice) }}</div>
            </div>
            <div class="drug-process" v-if="item.ingredients && item.ingredients.length > 0" @click="handleAddIngredient(index,item.ingredients)">
                <span>辅料：</span>
                <span>{{ computedIngredients(item.ingredients) }}</span>
            </div>
            <div class="drug-process" :class="{ 'pointerNone': item.isYlcp == '1' }" v-if="item.processFlag == 1"
                @click="openProcessDialog(index)">
                <span>加工：</span>
                <span v-if="item.process.processName == '熬药'">
                    <span>{{ item.process.processName }}</span>
                    <span v-show="![null, undefined, ''].includes(item.process.bagNum)">，一剂{{ item.process.bagNum }}袋</span>
                    <span v-show="![null, undefined, ''].includes(item.process.bagNumSum)">，共{{ item.process.bagNumSum }}袋</span>
                </span>
                <span v-if="item.process.processName != '熬药'">{{ item.process.processName }}</span>
                <span v-if="item.isYlcp != '1' || isOldYl">，加工费¥{{ item.process.processPrice }}</span>
                <span v-if="item.isYlcp == '1' && !isOldYl">，加工费¥{{ computedMultiplication(item.process.processPrice, item.doseNum) }}</span>
            </div>
        </div>
        <CustomDialog title="加工信息" v-if="dialogShow" :visible.sync="dialogShow" width="450px" @save="submit"
            submitText="保存" @cancel="cancel" @close="cancel">
            <processDialog slot="content" ref="processDialog" :newProcessFrom="newProcessFrom"
                :doseNum="(drugItems[currentIndex].doseNum || 1)" :weight="drugItems[currentIndex].weight">
            </processDialog>
        </CustomDialog>
        <customDialogOld title="处方模版" v-if="prescriptionTemplateShow" :visible.sync="prescriptionTemplateShow"
            dialogWidth="980px" @close="prescriptionTemplatecCancel" :showFooter="false">
            <prescriptionTemplateDialog @cancel="prescriptionTemplatecCancel" @recipeInfoBack="recipeInfoBack">
            </prescriptionTemplateDialog>
        </customDialogOld>
        <!-- 中药处方预览 -->
        <prescriptionPreview :drugObj="previewObj" :drugVisible="previewVisible" @closePreview="closePreview">
        </prescriptionPreview>
        <!-- 新增 模板 -->
        <addTemplateDialog v-if="addTemplateDialogShow" recipeTypeAction="diagnosisAdd" :doctorId="doctorInfo.doctorId"
            :form="addTemplateForm" recipeType="2" :dialogShow="addTemplateDialogShow" title="新增模版"
            @templateCancel="templateCancel" @saveSuceess="saveSuceess"></addTemplateDialog>
        <!-- 辅料模版 -->
        <ingredient-template ref="ingredientTemplate" :doctorId="doctorInfo.doctorId" @addIngredient="addIngredient" @useTemplate="useTemplate"></ingredient-template>
        <!-- 新增辅料 -->
        <add-ingredient ref="addIngredient" :doctorId="doctorInfo.doctorId" @useIngredient="useIngredient" @editTemplateSuccess="editTemplateSuccess"></add-ingredient>
    </div>
</template>

<script>
import { DRUG_TYPE, handlingOptions, doseOptions, remarkOptions, drugMethodOptions, frequencyOptions, takingDosageOptions, takeDaysOptions, applicationTimeOptions, soakTimeOptions, takeAmountFOptions, takeAmountGOptions, takeAmountWOptions, doseCanChooseList, doseCanChooseKeys,ybPropertyList } from '@/utils/const'
import { drugList, drugTypeConvert, drugListByKindId } from "@/api/drug"; // 药品请求
import { isNull, deepClone, msgboxWarning, debounce, uniqueArray, dictText,isArray } from '@/utils/validateBase'
import customTable from '@/components/customTable/customTable'
import customDialogOld from '@/components/customDialog/index.vue'
import CustomDialog from '@/components/customDialog/CustomDialog.vue'
import processDialog from '../processDialog/index'
import { processingPrice } from "@/api/processing"; // 获取加工请求
import { removeRecipe } from '@/api/pricingDetails'
import { Utils } from '@/utils/utils';
import prescriptionPreview from '../prescriptionPreview/prescriptionPreview.vue'
import prescriptionTemplateDialog from '../prescriptionTemplateDialog/index'
import { ybCenterDrugDirectoryCategorySignList } from '@/utils/const'
import { isEmptyArray } from '../../../../utils/validateBase';
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { Outpatient } from '../data/index.js'
import { drugDTO } from '@/DTO/drug/index'
import { imgArr } from '@/assets/images/img.js';
import addTemplateDialog from '@/views/MedicalTemplate/addTemplateDialog'
import SelectPanel from '@/components/SelectPanel.vue'
import Template from '../../../MedicalInsurance/Account/template.vue';
import ingredientTemplate from '../component/ingredientTemplate'
import addIngredient from '../component/addIngredient.vue';
export default {
    name: 'drug',
    // 定义引入的组件
    components: { vuedraggable, customTable, customDialogOld, processDialog, prescriptionPreview, prescriptionTemplateDialog, CustomDialog, addTemplateDialog, SelectPanel, Template,ingredientTemplate,addIngredient },
    props: {
        drugOftenUsageList: Array,
        editForm: Object,
        patientForm: Object,
        drugItem: Array,
        type: String | Number,
        consultationType: String | Number,
        isDisabled: Boolean,
        orderId: Number,
        uniOrderNumber: String | Number,
        createTime: String,
        repeatVisitInfo: Object,
        doctorInfo: Object,
        isEdit: Boolean,
        isOldYl: Boolean,
    },
    data() {
        return {
            starImgMap: {
                starOn: require('@/assets/images/star_on.png'),
                starOff: require('@/assets/images/star_off.png')
            },
            itemParams: {},
            imgArr: imgArr,
            drugItems: [],
            handlingOptions: handlingOptions,
            column: [
                { label: "商品名称", prop: "itemName", width: '150', align: 'left', slotHeader: 'itemNameHeader' },
                { label: "规格", prop: "spec", width: '120', align: 'left'},
                { label: "类型", prop: "firstCategoryName", align: 'left', width: '70', },
                { label: "库存", prop: "inventory", align: 'right', width: '100', },
                { label: "单位", prop: "itemUnit", width: '40', },
                { label: "零售价", prop: "price", align: 'right', width: '100' },
                {
                    label: "医保属性", width: '100', prop: "medicalInsuranceType", formatter: (row => {
                        return isNull(row.medicalInsuranceType) ? '-' : dictText(row.medicalInsuranceType, ybPropertyList)
                    })
                },
                { label: "spuId", prop: "spuId", align: 'left', width: '80', },
            ],//表头
            recipeList: DRUG_TYPE,//药品类别列表
            drugList: [],//药品列表
            doseOptions: doseOptions,//剂量列表
            remarkOptions: remarkOptions,//备注
            drugMethodOptions: drugMethodOptions,// 使用方式
            frequencyOptions: frequencyOptions,// 服用频次
            takingDosageOptions: takingDosageOptions,// 服用频次
            takeDaysOptions: takeDaysOptions,//服用多少天
            applicationTimeOptions: applicationTimeOptions,//贴敷时间
            soakTimeOptions: soakTimeOptions,//泡浴时间
            takeAmountFOptions: takeAmountFOptions,//打粉每次服用好多g
            takeAmountGOptions: takeAmountGOptions,//制膏每次服用多少
            takeAmountWOptions: takeAmountWOptions,//制丸每次服用多少
            dialogShow: false,//弹框显示
            currentIndex: '',//当前处方索引
            newProcessFrom: {},//加工对象
            drugListIndex: -1,
            previewObj: {},
            previewVisible: false,
            focusIndex: 0,//药品搜索框里输入框聚焦的索引  0药品 1用量
            prescriptionTemplateShow: false,//处方模版弹框
            DrugNote: {//中药处方事项
                doseFrequency: '1日1剂', // 剂量
                recipeMoment: '饭后服用', // 服用时间
                frequency: '1日3次', // 频率
                takingDosage: '每次200ml', // ml服用量
                takingDays: '服用10天', // 服用天数
                applicationTime: '约敷5分钟', // 贴敷使用时长
                wrapTime: '约泡20分钟', // 泡使用时长
                bakingPowderDosage: '每次10g', // 打粉服用量
                creamDosage: '每次20g', // 制膏服用量
                pelletizingDosage: '每次10g', // 制丸服用量
                mixingBagNum: '1' // 冲服
            },
            doseCanChoose: doseCanChooseList,
            deptId: this.$session.get('deptId'),
            newOrderId: null,
            doseTypeList: ['中药饮片', '中药颗粒', ''],//
            draggableFlag: false,//是否拖拽
            dragOptions: {
                animation: 200,
                draggable: '.drugItem',
                preventOnFilter: true,
                // easing: "cubic-bezier(1, 0, 0, 1)", // 动画缓动。默认为null。请参阅  示例。
                // handle: '.drag-warp',
                filter: ''
            },
            draggableDisabled: false,//拖拽禁用
            alreadyAdd: '',//是否添加过
            handleType: null,
            customTableText: '',//展示的table
            searchType: null,//搜索药品的type
            addTemplateDialogShow:false,//处方模版显示
            addTemplateForm:{},//新增模版对象
            btnSize:'medium',//按钮的大小
            curSerVal:'',//当前搜索的值
            isChangeType: false,//是否执行了切换类型：颗粒或者饮片
            isOwnedTip:'',//是否自备
            companyId:this.$session.get('user').companyId
        }
    },
    //变量监听
    watch: {
        'drugItem.length': function (newV, old) {
            this.$set(this, 'drugItems', this.drugItem);
            this.validOperateShowFn()
            this.$forceUpdate()
            // this.addMethod()
        },
    },
    computed: {
        computedDrugNoteList() {
            return function (v) {
                let matchKey = v.recipeMethod
                if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
                    matchKey = '煎服'
                }
                let option = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
                return option.label
            }
        },
        //更新库存
        computedInventory() {
            let that = this
            return function (spuId, list) {
                let arr = list.filter(val => val.spuId == spuId)
                if (_.isEmpty(arr)) return
                return arr[0].inventory
            }
        },
        computedOnsale() {
            let that = this
            return function (spuId, list) {
                let arr = list.filter(val => val.spuId == spuId)
                if (_.isEmpty(arr)) return
                return arr[0].onSale
            }
        },
        computedWeight() {
            return function (items) {
                let weight = 0
                items && items.forEach(obj => {
                    if (obj.itemUnit == 'g') {
                        weight = this.$bigNumber(weight, '+', obj.itemNum)
                    }
                })
                return weight;
            }
        },
        //乘法
        computedMultiplication() {
            return function (a, b) {
                if (isNull(a) || isNull(b)) return
                return this.$bigNumber(a, '*', b)
            }
        },
        computedIngredients(){
          return function(ingredientsTemplateDetails){
            let res =  ingredientsTemplateDetails.map(v2 => {
              let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
              if (v2.oriHandling) {
                str += v2.oriHandling;
              }
              return str;
            }).join('，');
            return res
          }
        }
    },
    // 页面初始化
    created() {
        this.addMethod()
        this.$nextTick(() => {
            this.initFn()
            this.validOperateShowFn()
        })
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        // 服用量失焦数字化处理
        mixingBagNumBlur(e) {
            if (![null, ''].includes(e.target.value)) {
                e.target.value = Number(e.target.value).toString()
            }
        },
        // 事件委托
        initFn() {
            let that = this
            document.addEventListener('click', function (e) {
                that.validOperateVisible()
            })
        },
        enterKid(kid, index, drugIndex) {
            this.$set(kid, 'deleteShow', true);
            this.handleOperateShowFn({ index, drugIndex, isShow: true })
            this.$forceUpdate();
        },
        leaveKid(kid, index, drugIndex) {
            this.$set(kid, 'deleteShow', false);
            this.handleOperateShowFn({ index, drugIndex, isShow: false })
            this.$forceUpdate();
        },
        //动态
        addMethod() {
            this.customTableText = ''
            // this.validTableDataDig()
            if (this.draggableFlag || this.handleType) {
                this.handleType = null;
                return
            }
            let drugItems = this.drugItem.map((val, ind) => {
                let inventoryIds = []
                val.items.forEach((k,i) => {
                    if(!isNull(k.spuId) && k.spuId > 0){
                      inventoryIds.push({spuId:k.spuId,type:k.doseType})
                    }
                    k.deleteShow = false;
                    k.doseType=isNull(k.doseType) ? val.doseType:k.doseType//先取本身的doseType
                })
                if (val.processFlag == '1' && _.isString(val.process.processingValue)) {
                    val.process.processingValue = JSON.parse(val.process.processingValue)
                }
                this.computeItemTotalPrice(val, ind, 2)
                // if(this.orderId!=this.newOrderId){
                // }
                this.getInventory(_.compact(_.uniq(inventoryIds)), val, val.doseType)
                return { ...val }
            })
            this.$set(this,'drugItems',drugItems)
        },
        //打印处方
        printerPrescription(item){
            if(_.isEmpty(item.items))return
            this.$emit('handlePrint',item)
        },
        //添加一个处方
        addDrugItem() {
            let drugItemList = _.cloneDeep(this.drugItems)
            let itemObj={
                
                    orderId: this.orderId,
                    projectType: '0',//0处方项目
                    recipeType: 1,//中药处方
                    doseNum: 1,//
                    recipeSourceType:0,
                    doseType: '0',//颗粒，饮片，全部
                    recipeMethod: '煎服',//煎法
                    recipeMoment: '',//服用时机
                    frequency: '',
                    takingDosage: '',
                    takingDays: '',
                    applicationTime: '',
                    wrapTime: '',
                    bakingPowderDosage: '',
                    creamDosage: '',
                    pelletizingDosage: '',
                    doseFrequency: '',
                    mixingBagNum: '1',//冲服
                    weight: 0,//药品总重
                    processFlag: '0',//是否加工
                    process: {//加工信息
                        processName: '',
                        processPrice: '',
                        bagNum: '',
                        remark: '',
                        processingValue: "[]"
                    },
                    items: [
                        {
                            itemName: '',
                            itemNum: '',
                            itemUnit: 'g',
                            deleteShow: false,//是否显示删除icon
                            handling: '',
                            doseType: '0',
                        }
                    ],
                  ingredients:[]
                
            }
            itemObj = this.matchOftenUsageList(itemObj.recipeMethod, itemObj)
            drugItemList.push(itemObj)
            this.handDrugs(itemObj, drugItemList.length-1)
            this.$set(this,'drugItems',drugItemList)
            this.$emit('updateDrugItem', this.drugItems)
        },
        //获取药品库存并更新
        getInventory(spu, val, type) {
            if (this.isDisabled) return;
            this.newOrderId = this.orderId
            if (_.isEmpty(spu)) return;
            this.isNewInventory = true;
            Outpatient.getInventory({
                spu,
                deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.deptId,
                recipeType: '1'
            }).then(res => {
                this.updateItems(val.items,res.data)
            })

        },
        drugInput(event = {}, val, type, index, drugIndex) {
            this.$refs[`customTable${index}${drugIndex}`][0].$children[0].bodyWrapper.scrollTop = 0;
            let value = event.target.value || val;
            let dom = this.$refs[`popover${index}${drugIndex}`] || []
            dom[0] && dom[0].doShow();
            this.curSerVal=value;//当前搜索的值
            this.getDrugList(value, type, index, drugIndex)
        },
        validTableDataDig(obj) {
            let itemParams = this.itemParams
            let _drugItems = this.drugItems
            if (_.isEmpty(obj)) {
                _drugItems.map((v, i) => {
                    v.items && v.items.map((vs, idx) => {
                        let dom = this.$refs[`popover${i}${idx}`]
                        dom && dom[0].doClose()
                    })
                })
            } else {
                let dom = this.$refs[`popover${itemParams.index}${itemParams.drugIndex}`]
                dom && dom[0].doClose()
            }
        },

        // this.$set(this, 'drugItems', drugItems)
        //搜索药品切换
        changeSearchType(val, type, index, drugIndex) {
            this.isChangeType=true;
             //切换药品当前input失焦了，手动聚焦一次
             let _searchDom = this.$refs[`search${index}${drugIndex}`]
            _searchDom && _searchDom[0].focus()
            // this.drugItems[index].items[drugIndex].doseType='0' ? '1' : '0';
            // let changeType = type == '0' ? '1' : '0';
            this.searchType= this.searchType == '0' ? '1' : '0';
            // this.$set(this.drugItems[index].items[drugIndex], 'doseType', changeType)
            // this.$forceUpdate()
            let real = isNull(val) ? this.curSerVal : val;
            this.drugItems[index].items[drugIndex].itemName = real;//失焦重新赋值
            this.getDrugList(real, this.searchType, index, drugIndex);
            this.isChangeType=false;
        },
        /**
         * 请求药品列表
         * val 药品名字
         * type 药品类型
         */
        getDrugList: debounce(function (val, type, index, drugIndex) {
            let name = this.drugItems[index].items[drugIndex].itemName
            // if (isNull(val) && isNull(name)) {
            //     this.drugItems[index].items[drugIndex].itemId = null;
            //     this.drugItems[index].items[drugIndex].itemName = '';
            //     this.drugItems[index].items[drugIndex].itemNum = '';
            //     this.drugItems[index].items[drugIndex].oldDrugName = '';
            //     this.computeItemTotalPrice(this.drugItems[index], index);
            //     this.$emit('updateDrugItem', this.drugItems)
            //     return;
            // }
            if (isNull(val)) return;
            Outpatient.getOtherProject({deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.deptId, searchWord: val, types: [this.searchType || '0'],recipeType:1}).then(res => {
                this.customTableText = `customTable${index}${drugIndex}`;
                this.drugListIndex = 0
                if (this.focusIndex == 1) return;
                if (_.isEmpty(res)) {
                    this.drugList = []
                } else {
                    this.drugList = res
                    this.$nextTick(() => {
                        let dom = this.$refs[`customTable${index}${drugIndex}`]
                        dom && dom[0] && dom[0].$refs.customTable.setCurrentRow(this.drugList[this.drugListIndex])
                    })
                }
            })
        },200),
        /**
         * 点击药品表格
         * index 处方索引
         * @param {*} row 
         */
        async rowClick(row, index, drugIndex) {
            let drugItem = deepClone(this.drugItems)
            let obj = deepClone(this.drugItems[index].items[drugIndex])
            obj = { ...obj, ...row,onSale:'1' }
            obj.oldDrugName = row.itemName
            let tempObj=_.cloneDeep(obj)
            this.alreadyAdd = '';//是否添加过
            let recipeDrugItem = drugItem[index].items||[]
            let length = drugItem[index].items.length
            let _index = recipeDrugItem.findIndex(item => {
              if (item.itemId && item.itemName && (item.itemId == obj.itemId || item.itemName == obj.itemName)) {
                  return true
              }
            })
           //列表中除了当前这个药还存在相同的药，则提示已经添加过  update by wjx
           if (Utils.gt(_index, -1) && !Utils.eq(_index, drugIndex)) {
            this.alreadyAdd = `note+ ${index} + ${drugIndex}`
                setTimeout(() => {
                    this.alreadyAdd = '';//是否添加过
                }, 2000)
                // this.$refs[`popover${index}${drugIndex}`][0].doClose()
                this.customTableText = ''
                this.drugList = [];
                this.drugItems[index].items[drugIndex].itemName = null
                return
            }
            this.$set(this.drugItems[index].items, drugIndex, obj)
            if (length == 1 || drugIndex == length - 1) {
                this.addSearch(this.drugItems[index].items, index)
            }
            this.computeItemTotalPrice(this.drugItems[index], index);
            this.customTableText = ''
            this.drugList = []
            this.$nextTick(() => {
                this.$refs[`dosage${index}${drugIndex}`][0].focus()
            })
            this.searchType=null;
            this.curSerVal=''
            this.drugListIndex = -1
            const newDrug = this.drugItems[index].items[drugIndex]
            const oftenDecoction = await Outpatient.getOftenDecoction(newDrug.spuId)
            if (oftenDecoction && oftenDecoction.handling) {
                newDrug.handling = oftenDecoction.handling
            } else {
                newDrug.handling = ''
            }
        },
        /**
         * 药品输入框失去焦点
         */
        drugSearchBlur(index, drugIndex) {
            let drugItem = deepClone(this.drugItems)
            let recipeDrugItem = drugItem[index].items
            recipeDrugItem[drugIndex].itemName = recipeDrugItem[drugIndex].oldDrugName
            this.drugListIndex = -1
            this.drugItems[index].items[drugIndex].isFocus = false;
            this.drugItems[index].items[drugIndex].itemName = recipeDrugItem[drugIndex].oldDrugName
            this.$forceUpdate()
            this.$emit('updateDrugItem', drugItem)
            this.validOperateShowFn({ index, drugIndex })
            // this.$set(this, 'drugItems', drugItem)
        },
        /**
         * 输入药品用量
         */
        // formatNum: debounce(function (e, kid, item, index) {
        formatNum: debounce(function (e, kid, item, index) {
            if(!isNull(e)){
              let temp = e.toString();
              temp = temp.replace(/。/g, ".");
              temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
              temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
              temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
              temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
              temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
              kid.itemNum = Number(temp);
            }
            this.estimateTakingDays(item)
            this.computeItemTotalPrice(item, index)
        },800),
        // }, 200),
        /**
         * 选择药品煎法
         * index 处方索引
         * drugIndex 药品索引
         */
        chooseUsage(val, index, drugIndex) {
            let drugItem = deepClone(this.drugItems)
            drugItem[index].items[drugIndex].handling = val
            this.$emit('updateDrugItem', drugItem)
            this.handDrugs(drugItem[index], index)
            if (![null, undefined, ''].includes(drugItem[index].items[drugIndex].spuId)&&drugItem[index].items[drugIndex]['rememberDecoction'] === true && ![null, undefined, ''].includes(drugItem[index].items[drugIndex].handling)) {
                Outpatient.saveOftenDecoction(drugItem[index].items[drugIndex].spuId, drugItem[index].items[drugIndex].handling, 1)
            }
        },
        /**
         * 删除药品
         * * index 处方索引
         * drugIndex 药品索引
         */
        removeDrug(index, drugIndex) {
            this.drugItems[index].items.splice(drugIndex, 1)
            this.estimateTakingDays(this.drugItems[index])
            this.computeItemTotalPrice(this.drugItems[index], index);
        },
        /**
         * 删除中药处方
         *  index 处方索引
         */
        deleteDrugItem(index, id) {
            msgboxWarning(this, {
                message: `是否确定删除该处方？`,
                confirmFn: () => {
                    let drugItem = deepClone(this.drugItems)
                    if (isNull(id)) {
                        drugItem.splice(index, 1);
                        this.$set(this, 'drugItems', drugItem)
                        this.$forceUpdate()
                        this.$emit('updateDrugItem', drugItem)

                    } else {
                        Outpatient.removePrescription({ orderCaseProjectRecipeId: id }).then(res => {
                            drugItem.splice(index, 1)
                            this.$set(this, 'drugItems', drugItem)
                            this.$emit('updateDrugItem', drugItem)
                            this.$forceUpdate()
                        })
                    }
                },
                cancelFn: () => {
                },
            });
        },
        /**
         * 加工
         *  index 处方索引
         */
        handleProcess(index) {
            this.currentIndex = index
            let { processFlag, doseNum } = this.drugItems[index]
            if (processFlag == '1') {
                let drugItem = deepClone(this.drugItems)
                drugItem[index].processFlag = '0'
                drugItem[index].process.bagNum = ''
                drugItem[index].process.bagNumSum = ''
                drugItem[index].process.processPrice = 0
                drugItem[index].process.processName = ''
                drugItem[index].process.processingValue = '';
                this.$set(this, 'drugItems', drugItem)
                this.$emit('updateDrugItem', drugItem)
                this.computeItemTotalPrice(drugItem[index], index)
            } else {
                let processFrom = {
                    processingValue: ['熬药'],
                    bagNum: '3',
                    bagNumSum: this.$bigNumber('3', '*', (doseNum || 1)),
                    processPrice: '',
                    processName: '熬药'
                }
                this.newProcessFrom = processFrom;
                this.dialogShow = true
            }
        },
        /**
         * 弹框确定
         */
        submit() {
            let newProcessFrom = this.$refs.processDialog.newProcessFrom;
            this.drugItems[this.currentIndex].process = { ...newProcessFrom }
            this.drugItems[this.currentIndex].processFlag = '1';
            this.handDrugs(this.drugItems[this.currentIndex], this.currentIndex)
            this.computeItemTotalPrice(this.drugItems[this.currentIndex], this.currentIndex, 1)
            this.cancel()
            this.$forceUpdate()
        },
        /**
         * 取消按钮
         */
        cancel() {
            this.dialogShow = false
        },
        /**
         * 打开加工弹框
         */
        openProcessDialog(index) {
            if (this.isDisabled) return;
            this.currentIndex = index
            let { process,processFlag } = this.drugItems[index]
            let processFrom = { ...process }
            if (processFlag == '1' && _.isString(processFrom.processingValue)) {
                processFrom.processingValue = JSON.parse(processFrom.processingValue)
            }
            this.newProcessFrom = processFrom
            this.dialogShow = true
        },
        /**
         * 
         */
        numberInputMove(e, type, index, drugIndex) {
            this.validOperateVisible();
            let height = 0;
            let _dom = this.$refs[`customTable${index}${drugIndex}`]
            let currentItem = this.drugItems[index].items[drugIndex] || {}
            let dom = _dom && _dom[0] && _dom[0].$el.querySelector('.el-table__body-wrapper')
            if (this.drugListIndex >= 3) {
                height = 32
            }
            switch (type) {
                case 'up':
                    if (this.focusIndex == 1) {
                        let operDom = this.$refs[`dosage${index}${drugIndex}`]
                        operDom && operDom[0].focus()
                    } else {
                        if (Utils.gt(this.drugListIndex, 0)) {
                            this.drugListIndex--;
                        }
                        dom.scrollTop = dom.scrollTop - height
                        _dom && _dom[0].$refs.customTable.setCurrentRow(this.drugList[this.drugListIndex])
                    }
                    break;
                case 'down':
                    if (this.focusIndex == 1) {
                        let operDom = this.$refs[`operate${index}${drugIndex}`]
                        operDom && operDom[0].focus()
                    } else {
                        if (Utils.gt(this.drugList.length - 1, this.drugListIndex)) {
                            this.drugListIndex++;
                        }
                        dom.scrollTop = dom.scrollTop + height
                        _dom && _dom[0].$refs.customTable.setCurrentRow(this.drugList[this.drugListIndex])
                    }
                    break;
                case 'left':
                    // 确认只弹出一个弹窗
                    this.validTableDataDig()
                    this.validOperateShowFn()
                    if (this.focusIndex == 1) {
                        this.$refs[`search${index}${drugIndex}`][0].select()
                        this.focusIndex = 0
                    } else if (this.focusIndex == 0) {
                        drugIndex = this.$bigNumber(drugIndex, '-', 1)
                        if (Utils.lt(drugIndex, 0)) return
                        this.$refs[`dosage${index}${drugIndex}`][0].select()
                        this.focusIndex = 1
                    }
                    break;
                case 'right':
                    // 确认只弹出一个弹窗
                    this.validTableDataDig()
                    this.validOperateShowFn()
                    if (this.focusIndex == 0) {
                        this.$refs[`dosage${index}${drugIndex}`][0].select()
                        this.focusIndex = 1
                    } else if (this.focusIndex = 1) {
                        drugIndex++
                        this.$refs[`search${index}${drugIndex}`][0].select()
                        // this.searchFocus(index, drugIndex)
                        this.focusIndex = 0
                    }
                    break;
            }
        },
        /**
         * 药品类型一键转换
         * @param {*} obj 
         */
        typeChange(e, item, index) {
            this.customTableText=''
            this.validTableDataDig()
            let pre = this.$refs.select[index].value;
            if (Utils.gt(item.items.length, 1)) {
                let typeStr = e == '0' ? '中药饮片' : e == '1' ? '中药颗粒' : ''
                msgboxWarning(this, {
                    message: `是否将处方中的所有药品转为${typeStr == '' ? '全部' : typeStr}`,
                    confirmFn: async () => {
                        item.doseType = e;
                        item.items.pop()
                        let spu = []
                        item.items.forEach(v=>{
                          spu.push({spuId:v.spuId,type:e})
                        })
                        let { code,data } = await drugDTO.drugTypeConvert({targetType:e,srcType:item.items[0].doseType,deptId: this.$session.get('deptId'),drugList:item.items})
                        if(code==200){
                          item.items.forEach(v1=>{
                            data.unmatchDrugList && data.unmatchDrugList.forEach(v2=>{
                              if(v1.spuId == v2.spuId){
                                v1.onSale = '0'
                                v1.doseType = e
                              }
                            })
                          })
                          item.items.forEach(v1=>{
                            data.newDrugList && data.newDrugList.forEach(v2=>{
                              if(v1.spuId == v2.srcSpuId){
                                v1.inventory=v2.inventory,
                                v1.medicalInsuranceType=v2.medicalInsuranceType,
                                v1.price=v2.price, 
                                v1.doseType= v2.firstCategory,
                                v1.itemName= v2.spuCommonName,
                                v1.oldDrugName = v2.spuCommonName
                                v1.itemUnit= v2.unit,
                                v1.onSale='1',
                                v1.spuCommonName=v2.spuCommonName,
                                v1.spuId=v2.spuId
                                v1.itemId = v2.spuId
                              }
                            })
                          })
                          this.computeItemTotalPrice(item,index)
                          this.addSearch(item.items,index);
                          this.handDrugs(item, index)
                          this.validOperateShowFn()
                        //   let newItem = deepClone(item)
                        //   this.$set(this.drugItems,index,newItem);
                        }
                    },
                    cancelFn: () => {
                        item.doseType = pre
                    },

                });
            }else{//还没输入药品的时候就转换类型
                item.doseType = e;
                if(!_.isEmpty(item.items))item.items[0].doseType = e;
                this.$set(this.drugItems, index, item);
            }
        },
	//计算加工费,只有计量发生改变更新加工费
        async computeProcessPrice(obj, index,) {
            if (obj.processFlag == '0') return;//如果没有加工不需要重新计算加工费
            let params = { number: (obj.doseNum || 1), processingType: obj.process.processName, weight: obj.weight, bagNumber: obj.process.bagNum, bagNumberSum: (obj.process.bagNum * (obj.doseNum || 1)) };
            let { code, data } = await processingPrice(params);
            if (code == 200) {
                obj.process.processPrice = data;
                obj.process.bagNumSum = this.$bigNumber(obj.process.bagNum, '*', (obj.doseNum || 1))
                this.$set(this.drugItems, index, obj)
            }
        },
        // 计算当前变动中药处方的总价
        async computeItemTotalPrice(obj, index, type) {
            // if (obj.processFlag == '0') {
            obj.totalPrice = '0';
            computeDrugPrice(obj, this);
            obj.totalPrice = this.$toFixed(obj.totalPrice);
            this.$forceUpdate();
            function computeDrugPrice(obj, _this, index) {
                obj.weight = 0
                // 处理药品价格
                if (obj.items.length > 0) {
                    obj.items.forEach(item => {
                        let tempWeight=0
                        let tempPrice=0
                        let tempTotal=0
                        if(item.isOwned && item.isOwned == '0'){
                            tempPrice = _this.$bigNumber(item.price, '*', item.itemNum)
                            tempTotal = _this.$bigNumber(tempPrice, '*', (obj.doseNum || 1), 2)
                            obj.totalPrice = _this.$bigNumber(tempTotal, '+', obj.totalPrice, 2)
                        }
                        if(item.itemUnit=='g'){
                            tempWeight = _this.$bigNumber(item.itemNum, '*', (obj.doseNum || 1))
                        }
                        obj.weight = _this.$bigNumber(tempWeight, '+', obj.weight, 2)
                    });
                }

            }
            if (!type) {
                await this.handDrugs(obj, index)
            }
            if (type && type != 2) {
                this.$emit('updateDrugItem', this.drugItems)
            }

        },
        /**
       * 预览处方
       */
        handlelook(obj) {
            let newObj = deepClone(obj)
            newObj.items.pop()
            this.previewObj = {
                ...newObj,
                patientInfo: this.patientForm,
                editForm: this.editForm,
                uniOrderNumber: this.uniOrderNumber,
                createTime: this.createTime,
                repeatVisitInfo: this.repeatVisitInfo,
                doctorInfo: this.doctorInfo
            }
            this.previewVisible = true
        },
        /**
         * 药品搜索框聚焦
         */
        searchFocus(index, drugIndex) {
            // drugIndex = this.$bigNumber(drugIndex, '+', 1)
            drugIndex++
            if (Utils.eq(drugIndex, this.drugItems[index].items.length)) return;
            // this.$refs[`search${index}${drugIndex}`][0].focus()
            let _dosDom = this.$refs[`dosage${index}${drugIndex}`]
            let _searchDom = this.$refs[`search${index}${drugIndex}`]
            let _item = this.drugItem[index].items[drugIndex]
            if(!_item.itemName){
                _searchDom&&_searchDom[0].focus()
            }else if(_dosDom&&_dosDom[0]){
                _dosDom[0].focus()
                _dosDom[0].select()
            }
        },
        /**
         *  用量输入框聚焦 
         */
        dosageFocus(index, drugIndex) {
            this.itemParams = { index, drugIndex }
            // this.draggableDisabled = true
            this.focusIndex = 1;
            this.customTableText = ''
            let dom = this.$refs[`dosage${index}${drugIndex}`]
            dom && dom[0].select()
            this.drugItems[index].items[drugIndex].isFocus = true
            this.validTableDataDig()
            setTimeout(() => {
                this.handleOperateShowFn({ index, drugIndex, isShow: true })

            }, 1)
        },
        closePreview() { this.previewVisible = false },
        /**
         * 关闭处方模版
         */
        prescriptionTemplatecCancel() {
            this.prescriptionTemplateShow = false
            this.currentIndex = ''
        },
        /**
         * 打开处方模版弹框
         */
        openPrescriptionTemplateDialog(index) {
            this.prescriptionTemplateShow = true;
            this.currentIndex = index
        },
        /**
          * 使用处方模版
        */
        recipeInfoBack(val) {
            if (val.type == 0) this.useRecipeDrugDemo(val); // 中药模板
            else {
                this.$confirm('您选择的模板为理疗处方，是否新建一个处方？', '提示', {
                    confirmButtonText: '新建理疗处方',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.prescriptionTemplateShow = false
                    this.$emit('useRecipePhysioDemo', val)
                    // this.useRecipePhysioDemo(val); // 理疗模板
                }).catch(() => {
                    this.prescriptionTemplateShow = false;
                });
            }
        },
        /**
         * 使用中药模板
        */
        async useRecipeDrugDemo(obj) {
            let spu = [];
            obj.recipeTemplateDrugs.forEach(item => { 
              if(item.spuId > 0){
                spu.push({spuId:item.spuId,type:item.firstCategory,requiredQuantity:this.$bigNumber(item.number,'*',obj.doseNum)}) 
              }
            });
            let recipeDrugItem = [];
            // 通过kinId获取药品详情列表
            let { data } = await Outpatient.getInventory({
                spu,
                deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
                recipeType: '1',
                useReplaceSpu:true,
            })
            obj.recipeTemplateDrugs.forEach(kid => {
                if (isNull(kid.spuId) || kid.spuId < 0 || kid.spuId == 0) {
                    recipeDrugItem.push({ ...kid, id: kid.spuId })
                }
                data.forEach(item => {
                    if (item.spuId == kid.spuId && !item.replaced) {
                      recipeDrugItem.push({ ...kid, ...item,isOwned:'0',doseType:item.goodsType })
                    }else if(item.replaced && kid.spuId == item.originalSpuId){
                      recipeDrugItem.push({ ...kid, ...item,isOwned:'0',doseType:item.goodsType })
                    }
                })
            })
            // 计算处方价格和重量
            let totalPrice = 0,
                weight = 0;
            recipeDrugItem.forEach(item => {
                item.oldDrugName = item.spuCommonName
                totalPrice = this.$bigNumber(totalPrice, '+', this.$bigNumber(item.price, '*', item.number));
                weight = this.$bigNumber(weight, '+', item.number);
            });
            let drugItem = deepClone(this.drugItems)
            drugItem[this.currentIndex].items.pop();
            recipeDrugItem = this.nameChange(recipeDrugItem)
            let newDrugList = [...drugItem[this.currentIndex].items, ...recipeDrugItem]
            newDrugList = uniqueArray(newDrugList, 'spuId')
            drugItem[this.currentIndex].items = newDrugList
            //加上处方id和是否是医联
            drugItem[this.currentIndex].sourceRecipeId = obj.recipeTemplateId
            drugItem[this.currentIndex].isYlcp = obj.isYlcp
            this.estimateTakingDays(drugItem[this.currentIndex])
            this.computeItemTotalPrice(drugItem[this.currentIndex], this.currentIndex);
            this.$set(this, 'drugItems', drugItem);
            this.addSearch(newDrugList, this.currentIndex)
            this.$emit('updateDrugItem', drugItem);
            this.validOperateShowFn()
            // this.handDrugs(drugItem[this.currentIndex], this.currentIndex)
            this.prescriptionTemplateShow = false;
            
            this.$message.success('追加模版成功');
        },
        /**
         * 添加空白搜索框
         * drugList
         */
        addSearch(drugList, index) {
            let doseType=this.drugItems[index].doseType
            let _obj = {
                itemName: '',
                itemNum: '',
                itemUnit: 'g',
                deleteShow: false,//是否显示删除icon
                handling: '',
                doseType: doseType==2?'0':doseType || 0,
            }
            let len = this.drugItems[index].items.length
            this.$set(this.drugItems[index].items, len, _obj)
        },
        doseNumChange: debounce(async function (item, index) {
            if (!item.doseNum) {
                item.doseNum = null
            }
            item.doseNum = item.doseNum && item.doseNum.replace(/^(0+)|[^\d]+/g, '');
            this.estimateTakingDays(item)
        if(item.processFlag=='1')  await this.computeProcessPrice(item, index)
            this.computeItemTotalPrice(item, index);
            this.$emit('updateDrugItem', this.drugItems);
        }, 500),
        /**
         * 处理drugItem数据
         * 
         */
        handDrugs(item, index, type, isClean = false) {
            if (this.isDisabled) return;
            let drug = _.cloneDeep(item);
            drug.items = drug.items.filter(v => v.itemName)
            drug.items = drug.items.map(kid => {
                return {...kid}
            })
            if (drug.processFlag == '1' && isArray(drug.process.processingValue)) {
                drug.process.processingValue = JSON.stringify(drug.process.processingValue)
            };
            if (isClean) {
                drug = this.matchOftenUsageList(drug.recipeMethod, drug)
                this.$set(this.drugItems, index, this.matchOftenUsageList(this.drugItems[index].recipeMethod, this.drugItems[index]))
            }
            let obj = {
                ...drug
            }
             //如果是编辑的话不要执行实时保存
             if (this.isEdit) {
                // this.addSearch(obj,index)
                let drugItems=_.cloneDeep(this.drugItems)
                obj.items.push({
                    itemName: '',
                    itemNum: '',
                    itemUnit: 'g',
                    deleteShow: false,//是否显示删除icon
                    handling: '',
                    doseType: obj.doseType==2?'0':obj.doseType || 0,
                })
                this.drugItems[index]=obj
                this.$forceUpdate();
                drugItems[index]=obj
                this.$emit('updateDrugItem', drugItems);
                return
            }
            Outpatient.editPrescription(obj).then(res => {
                if (!drug.orderCaseProjectRecipeId) {
                    this.drugItems[index].orderCaseProjectRecipeId = res.data;
                }
                this.handleType = type
                this.$forceUpdate();
                let drugItems=_.cloneDeep(this.drugItems)
                this.$emit('updateDrugItem',drugItems);
                // this.$emit('updateDrugItem', {type,...this.drugItems});
            })
        },
        nameChange(list) {
          return list.map(kid => {
              return {
                  ...kid,
                  itemId: kid.spuId,
                  itemName: kid.spuCommonName,
                  spuId: kid.spuId,
                  itemNum: kid.number,
                  itemUnit: kid.unit,
                  price: kid.price,
                  inventory: kid.inventory,
                  isOwned:isNull(kid.isOwned) ? '0': kid.isOwned,
                  handling: kid.handling,
                  deleteShow: false,
                  oldDrugName: kid.spuCommonName,
                  doseType:isNull(kid.doseType) ? '0':kid.doseType,
                  medicalInsuranceType:kid.medicalInsuranceType
              }
          })

        },
        sortChange(sortObj, index, items) {
            const key = items.findIndex(v => [null, undefined, ''].includes(v.spuId))
            if (key !== -1) {
                const opt = JSON.parse(JSON.stringify(items[key]))
                items.splice(key, 1)
                this.addSearch(items, index)
            }
            this.draggableFlag = false
            // this.addSearch(items, index)
            this.computeItemTotalPrice(this.drugItems[index], index)
        },
        startChange(sortObj, items) {
            this.draggableFlag = true
            // if (items.length > 1) {
            //     this.validTableDataDig()
            //     let lastIndex = items.length - 1;
            //     items.splice(lastIndex, 1)
            // }
        },
        pointChange() {
            let itemParams = this.itemParams;
            this.validTableDataDig()
        },
        /**
         * 
         */
        drugFocus(itemName, doseType, index, drugIndex) {
            if(this.isChangeType)return
            this.searchType=doseType==2?'0':doseType || '0';
            this.drugList = []
            let pointDom = this.$refs[`point${index}${drugIndex}`][0];
            let searchDom = this.$refs[`search${index}${drugIndex}`][0].$el;
            let height = searchDom.getBoundingClientRect().top;
            let domHeight = document.documentElement.offsetHeight
            let downHeight = domHeight - height
            if (downHeight < 300) {
                const contentWarp = document.getElementsByClassName('content-warp')[0]
                contentWarp.scrollTo({
                    top: contentWarp.scrollTop + (300 - downHeight),
                    behavior: 'smooth'
                })
                // pointDom.scrollIntoView({ behavior: 'smooth' })
            }
            this.itemParams = {
                itemName, doseType, index, drugIndex
            }
            this.drugItems[index].items[drugIndex].isFocus = true
            this.setDrugFocus(itemName, doseType, index, drugIndex)
            this.handleOperateShowFn({ index, drugIndex, isShow: true })
        },
        // setDrugFocus: debounce(function (itemName, doseType, index, drugIndex) {
        setDrugFocus(itemName, doseType, index, drugIndex) {
            this.focusIndex = 0
            this.$refs[`search${index}${drugIndex}`][0].select()

            this.getDrugList(itemName, doseType, index, drugIndex);
            // }, 100)
        },
        operateEnterFn(obj) {
            this.searchFocus(obj.index, obj.drugIndex)
        },
        // 确保每次开启之前，其他统统关闭
        validOperateVisible() {
            let _drugItems = this.drugItems || []
            _drugItems.map((v, i) => {
                v.items && v.items.map(vs => {
                    vs.operateVisible = false;
                })
            })
            this.$set(this, 'drugItems', _drugItems)
        },
        // 校验煎法显示的规则  已经选择煎法了允许展示
        validOperateShowFn() {
            let _drugItems = this.drugItems || []
            _drugItems.map(v => {
                v.items && v.items.map(vs => {
                    vs.operateShow = !!vs.handling ? true : false
                })
            })
            this.$set(this, 'drugItems', _drugItems)
            this.$forceUpdate()
        },
        // 手动触发显示煎法
        handleOperateShowFn(obj) {
            let _drugItems = this.drugItems || []
            if (!_.isEmpty(obj)) {
                let isBol = !!_drugItems[obj.index].items[obj.drugIndex].handling || _drugItems[obj.index].items[obj.drugIndex].isFocus
                this.$set(_drugItems[obj.index].items[obj.drugIndex], 'operateShow', isBol || obj.isShow)
            }
            this.$set(this, 'drugItems', _drugItems)
            this.$forceUpdate()
        },
        // 用法用量失去焦点
        dosageBlurFn(obj) {
            // this.draggableDisabled = false;
            this.drugItems[obj.index].items[obj.drugIndex].isFocus = false
            this.validOperateShowFn()
        },
        preventDefault(event) {
            event.preventDefault();
        },
        /**
         * 保存为处方模版
         */
        savePrescriptionTemplate(item) {
            this.addTemplateForm = deepClone(item)
            let index = item.items && item.items.findIndex(obj => { return obj.onSale == '0' })
            if(index > -1) return this.$message.error('存在不可售商品，不支持保存处方模版')
            this.addTemplateForm.recipeTemplateDrugs = item.items.map(v => {
                return {...v}
            })
            this.addTemplateDialogShow = true
        },
        /**
        * 新增模版取消
        */
        templateCancel() {
            this.addTemplateDialogShow = false
        },
        /**
         * 处方模版保存
         */
        saveSuceess(data) {
            this.templateCancel()
        },
        // 服用量获取焦点
        mixingBagNumFocus(index) {
            this.$refs[`mixingBagNum_${index}`][0].focus()
        },
        // 煎法获取焦点
        async decoctionFocus(item) {
            if (item.spuId) {
                const oftenDecoction = await Outpatient.getOftenDecoction(item.spuId)
                if (oftenDecoction) {
                    this.$set(item, 'rememberDecoction', true)
                } else {
                    this.$set(item, 'rememberDecoction', false)
                }
            }
        },
        // 记住煎法
        rememberDecoction(item) {
            let rememberDecoction = true
            let enable = 1
            if (item['rememberDecoction'] === true) {
                rememberDecoction = false
                enable = 0
            }
            this.$set(item, 'rememberDecoction', rememberDecoction)
            if (![null, undefined, ''].includes(item.handling)) {
                Outpatient.saveOftenDecoction(item.spuId, item.handling, enable)
            }
        },
        // 匹配常用用法
        matchOftenUsageList(key = '煎服', item) {
            let matchKey = key
            const obj = JSON.parse(JSON.stringify(item))

            doseCanChooseKeys.forEach(key => {
                obj[key] = ''
            })

            if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
                matchKey = '煎服'
            }
            let defaultOftenUsageOption = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
            defaultOftenUsageOption.label.forEach((v) => {
                obj[v.id] = v.default
            })

            const defaultOftenUsageKeys = defaultOftenUsageOption.label.map(v => v.id)

            const remoteOftenUsageOption = this.drugOftenUsageList.find(v => v.recipeMethod === key)
            if (remoteOftenUsageOption) {
                Object.keys(remoteOftenUsageOption).forEach(k => {
                    if (defaultOftenUsageKeys.includes(k)) {
                        obj[k] = remoteOftenUsageOption[k]
                    }
                })
            }

            return obj
        },
        //是否自备
        handleIsOwned(index, drugIndex){ 
            let drugItem = deepClone(this.drugItems)
            let kid = drugItem[index].items[drugIndex]
            if(isNull(kid.isOwned) || kid.isOwned=='0'){ 
                kid.isOwned='1' 
                this.isOwnedTip = `note+ ${index} + ${drugIndex}`
                setTimeout(() => {
                    this.isOwnedTip = '';//是否添加过
                }, 2000)
            }else if(!isNull(kid.isOwned) && kid.isOwned=='1'){ 
                kid.isOwned='0'
            }
            this.$set(this, 'drugItems', drugItem)
            this.computeItemTotalPrice(this.drugItems[index], index);
        },
        updateItems(list1,list2,key='spuId'){
          list1 && list1.forEach(v1=>{
            list2 && list2.forEach(v2=>{
              if(v1[key] == v2[key]){
                v1.price = v2.price
                v1.inventory = v2.inventory
                v1.itemName = v2.spuCommonName
                v1.itemUnit = v2.unit
                v1.onSale = v2.onSale,
                v1.oldDrugName = v2.spuCommonName
              }
            })
          })
        },
        handleAddIngredient(index,ingredient = null){
          if (this.isDisabled) return;
          this.$refs.addIngredient.open({index,ingredient,type:'editIngredient'})
        },
        useIngredient(obj){
          let { ingredientsTemplateDetails,drugItemIndex} = obj
          let drugItem = deepClone(this.drugItems)
          drugItem[drugItemIndex].ingredients = ingredientsTemplateDetails
          this.$set(this, 'drugItems', drugItem)
          this.$refs.ingredientTemplate.handleClose()
          this.$refs.addIngredient.handleClose()
          this.handDrugs(drugItem[drugItemIndex], drugItemIndex)
        },
        useTemplate(obj){
          let { ingredientsTemplateDetails,drugItemIndex} = obj
          let drugItem = deepClone(this.drugItems)
          drugItem[drugItemIndex].ingredients = ingredientsTemplateDetails
          this.$set(this, 'drugItems', drugItem)
          this.handDrugs(drugItem[drugItemIndex], drugItemIndex)
        },
        handleIngredient(index){
          let drugItem = deepClone(this.drugItems)
          if(isNull(drugItem[index].ingredients) || isEmptyArray(drugItem[index].ingredients)){
            this.$refs.ingredientTemplate.open(index)
          }else{
            drugItem[index].ingredients = null
            this.$set(this, 'drugItems', drugItem)
            this.handDrugs(drugItem[index], index)
          }
        },
        addIngredient(obj){
          this.$refs.addIngredient.open(obj)
        },
        editTemplateSuccess(){
          this.$refs.ingredientTemplate.getTemplateList()
        },
        estimateTakingDays (item) {
            if (['制膏', '制丸', '打粉'].includes(item.recipeMethod)) {
                let weight = 0
                let frequency = item.frequency
                let dosage = ''

                item.items.forEach(v => {
                    if(v.itemUnit == 'g'){
                        const tempWeight = this.$bigNumber(v.itemNum, '*', (item.doseNum || 1))
                        weight = this.$bigNumber(tempWeight, '+', weight, 2)
                    }
                })

                switch (item.recipeMethod) {
                    case '制膏':
                        weight = Math.trunc((weight || 0) * 0.4)
                        dosage = item.creamDosage
                        break
                    case '制丸':
                        weight = Math.trunc((weight || 0) * 0.8)
                        dosage = item.pelletizingDosage
                        break
                    case '打粉':
                        weight = Math.trunc((weight || 0) * 0.8)
                        dosage = item.bakingPowderDosage
                        break
                }
                const takingDays = Utils.estimateTakingDays(weight, frequency, dosage)
                item.takingDays = takingDays
            }
        },
        doseSelectInput (item, id) {
            if (['frequency', 'creamDosage', 'pelletizingDosage', 'bakingPowderDosage'].includes(id)) {
                this.estimateTakingDays(item)
            }
        }
    },
}
</script>

<style lang="less" scoped src="./index.less"></style>

<style lang="less">
@borderColor: #E0E0E0;
.usage-popper {
        padding: 0 !important;
        border: 0;

    .usage-list {
        display: flex;
        flex-wrap: wrap;
            width: 360px;
        background: #FFFFFF;
        box-shadow: 0px 4px 8px 0px rgba(183, 183, 183, 0.25);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid @borderColor;
            box-sizing: border-box;
            .active-operate-item {
                background-color: #E8F4FF;
                color: #1890FF !important;
            }

            .usage-item {
                padding: 8px 6px;
                font-size: 14px;
                color: #000;
                cursor: pointer;
                width: 90px;
                box-sizing: border-box;
                height: 36px;
                border: 1px solid @borderColor;
                margin-right: -1px;
                margin-bottom: -1px;
                // margin-top: -1px;
                text-align: center;

                &:hover {
                    background: #D4E4FF;
                }
            }
        }

    }

    .search-popper {
        padding: 0 !important;

        .customTable {
            z-index: 9999;
            top: 25px;
            left: 0;
        }

        .change-icon {
            height: 12px;
            width: 12px;
        }
   

    .current-row {
        background: #458CFF !important;
        color: #FFFFFF;

        &>td {
            // background: #458CFF !important;
            // color: #FFFFFF;
            background-color: transparent !important;
        }

    }

    .el-table .cell {
        padding-right: 0px !important;
        padding-left: 8px !important;
    }

    .el-table__cell {
        line-height: 32px !important;
        padding: 0px !important;
    }

    .el-table__header-wrapper {
        height: 32px;


    }

    .el-table__row {
        height: 32px !important;
    }
 }
    
</style>